















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue';
import IconStopSale from '@/components/icons/IconStopSale.vue';
import OnboardAvailabilityForm from '@/components/OnboardAvailabilityForm.vue';
import OnboardPricingForm from '@/components/OnboardPricingForm.vue';
import { mapGetters, mapState } from 'vuex';
import { refreshWhatfix } from '@/utils/utils';

@Component({
  components: { AppModal, IconStopSale },
  computed: {
    ...mapGetters(['roomsNeedOnboardAvailability']),
    ...mapState({
      isOnRequest: (state: any) => state.dashboard.isOnRequest,
      lang: (state: any) => state.partner.lang,
    }),
  },
})
export default class ModalOnboard extends Vue {
  public get roomsNeedOnboardPrice() {
    return this.$store.getters.roomsNeedOnboardPrice;
  }

  public get showStepper(): boolean {
    if (this.isOnRequest) { return false; }
    return Boolean(process.env.VUE_APP_PRICING_ENABLED === '1'
      && this.roomsNeedOnboardPrice.length
      && this.roomsNeedOnboardAvailability.length);
  }
  @Prop() public readonly show!: boolean;
  public roomsNeedOnboardAvailability!: any;
  public isLoading = false;
  public showError = false;
  public currentStep = 1;
  public successMessage: any = '';
  public leftContent = {
    1: {
      title: 'onboard.firstStep.title',
      subTitle: 'onboard.firstStep.subTitle',
      imgSrc: require('../assets/images/onboarding.svg'),
      textHeader: '',
      textContent: 'onboard.firstStep.content',
    },
    2: {
      title: 'onboard.secondStep.title',
      subTitle: 'onboard.secondStep.subTitle',
      imgSrc: require('../assets/images/onboarding_2.svg'),
      textHeader: 'onboard.secondStep.header',
      textContent: 'onboard.secondStep.content',
    },
  };
  public rightContent = {
    1: {
      title: 'onboard.firstStep.formTitle',
      subTitle: 'onboard.firstStep.formSubTitle',
      formComponent: OnboardAvailabilityForm,
    },
    2: {
      title: 'onboard.secondStep.formTitle',
      subTitle: 'onboard.secondStep.formSubTitle',
      formComponent: OnboardPricingForm,
    },
  };
  public isOnRequest!: boolean;
  private lang!: string;

  public alertSuccess() {
    this.$store.dispatch('addToast', {
      type: 'success',
      title: 'onboard.message.success.title',
      message: this.successMessage,
      timeout: 15,
      dismissBtn: process.env.VUE_APP_WHATFIX_ENABLED === '0',
    });
  }

  public showInfo() {
    const infoContent = {
      title: this.currentStep === 2 ? 'onboard.message.info.titlePrice' : 'onboard.message.info.title',
      message: this.currentStep === 2 ? 'onboard.message.info.contentPrice' : 'onboard.message.info.content',
    };
    this.$store.dispatch('addToast', {
      type: 'info',
      title: infoContent.title,
      message: infoContent.message,
      timeout: 15,
      dismissBtn: process.env.VUE_APP_WHATFIX_ENABLED === '0',
    });
  }

  public skip() {
    if (this.successMessage) {
      this.$store.dispatch('addToast', {
        type: 'success',
        message: this.successMessage,
        timeout: 7,
        callback: this.showInfo,
      });
    } else {
      this.showInfo();
    }
    this.closeModal();
  }

  public handleUpdateAvailability({message, appliedDate}: any) {
    this.successMessage = this.$i18n.t(message, appliedDate);
    if (!this.showStepper) {
      this.alertSuccess();
      this.closeModal();
    } else {
      this.currentStep = 2;
    }
  }

  public handleUpdatePricing({message, appliedDate}: any) {
    this.successMessage = `${this.successMessage} ${this.$i18n.t(message, appliedDate)}`;
    this.alertSuccess();
    this.closeModal();
  }

  private closeModal() {
    this.$store.dispatch('hideModal', 'onboarding');
    (window as any).enableWhatfix = 'enabled';
    refreshWhatfix(this.lang);
  }

  @Watch('isOnRequest', { immediate: true })
  private handleOnRequest(onRequest: boolean) {
    if (onRequest) {
      this.currentStep = 2;
    }
  }

  @Watch('roomsNeedOnboardAvailability', { immediate: true })
  private initStep(value: any) {
    if (Array.isArray(value) && value.length && !this.isOnRequest) {
      this.currentStep = 1;
    } else {
      this.currentStep = 2;
    }
  }
}
